import { ContactCornSchema } from '@eigtech/contacts-types';
import { DocumentCornSchema } from '@eigtech/documents-types';
import { z } from 'zod';
export const BaseTemplateSchema = z.object({
    id: z.string(),
    name: z.string(),
    lastUpdated: z.string().optional(),
    createdOn: z.string(),
    modifiedBy: z.string().optional(),
    carrierContactCorn: ContactCornSchema.optional(),
    reasonForUpdate: z.string().optional(),
});
// Communication Template
export const CommunicationTemplateTypeSchema = z.literal('templates:types:communication');
export const CommunicationTemplateSchema = BaseTemplateSchema.merge(z.object({
    type: CommunicationTemplateTypeSchema,
    smsTemplate: z.string().optional().nullable(),
    subject: z.string().optional(),
    htmlTemplate: z.string(),
    textTemplate: z.string().optional(),
}));
// Note template
export const NoteTemplateTypeSchema = z.literal('templates:types:note');
export const NoteTemplateSchema = BaseTemplateSchema.merge(z.object({
    type: NoteTemplateTypeSchema,
    textTemplate: z.string(),
    textTemplateParams: z.string().array().optional(),
}));
// Timeline template
export const TimelineTemplateTypeSchema = z.literal('templates:types:timeline');
export const TimelineInstructionOptionsSchema = z.object({
    from: z.string().array().optional(),
    label: z.string(),
    noRepeat: z.boolean().optional(),
    on: z.string().array().optional(),
    overridesOrder: z.boolean().optional(),
    order: z.number().optional(),
    requires: z.string().array().optional(),
    shouldNotSupersede: z.string().array().optional(),
    to: z.array(z.object({
        on: z.string().array(),
        key: z.string().or(z.undefined()),
        requires: z.string().array().optional(),
    })),
    unique: z.boolean().optional(),
});
export const TimelineInstructionTemplateSchema = z.record(z.string(), TimelineInstructionOptionsSchema);
export const TimelineTemplateSchema = BaseTemplateSchema.merge(z.object({
    type: TimelineTemplateTypeSchema,
    instructionTemplate: TimelineInstructionTemplateSchema,
    timelineType: z.string(),
    isLinear: z.boolean().optional(),
}));
export const DefaultTimelineTemplateSchema = TimelineTemplateSchema.omit({
    createdOn: true,
    id: true,
}).merge(z.object({
    createdOn: TimelineTemplateSchema.shape.createdOn.optional(),
    id: TimelineTemplateSchema.shape.id.optional(),
}));
// Util method for timeline service to validate specific templates
export const makeTimelineInstructionTemplateSchema = (eventType, pointType) => z.partialRecord(pointType, z.object({
    from: pointType.array().optional(),
    label: z.string(),
    on: eventType.array().optional(),
    order: z.number().optional(),
    overridesOrder: z.boolean().optional(),
    noRepeat: z.boolean().optional(),
    requires: pointType.array().optional(),
    shouldNotSupersede: pointType.array().optional(),
    to: z.array(z.object({
        on: eventType.array(),
        key: pointType.or(z.undefined()),
        requires: pointType.array().optional(),
    })),
    unique: z.boolean().optional(),
}));
export const DocumentTemplateTypeSchema = z.literal('templates:types:document');
export const DocumentTemplateSchema = BaseTemplateSchema.merge(z.object({
    documentId: DocumentCornSchema,
    type: DocumentTemplateTypeSchema,
}));
// Template
export const TemplateSchema = z.union([
    CommunicationTemplateSchema,
    DocumentTemplateSchema,
    NoteTemplateSchema,
    TimelineTemplateSchema,
]);
export const TemplateRecordSchema = z
    .object({
    PK: z.string(),
    SK: z.string(),
    'GSI-PK-1': z.string(),
    'GSI-SK-1': z.string(),
    deleted: z.boolean().optional(),
})
    .and(TemplateSchema);
export const TemplateTypesSchema = CommunicationTemplateTypeSchema.or(NoteTemplateTypeSchema)
    .or(TimelineTemplateTypeSchema)
    .or(DocumentTemplateTypeSchema);
